import { Platform, Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { Stack } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { Link, Redirect, Tabs, RelativePathString, usePathname, useRouter } from 'expo-router';
import { Button } from 'react95-native-rabbl';
import { Image } from 'expo-image';
import { AppText } from '@/components/AppText';
import DrawerButton from '@/components/DrawerButton';
import { HeaderLeft } from '@/components/HeaderLeft';

export default function TestsStack() {
  return (
    <Stack
      screenOptions={{
        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },

        headerTitle: (props) => <AppText {...props} style={CustomTextStyles.headerTitle} />,

        headerLeft: () => <HeaderLeft />,

        headerRight: () => <DrawerButton />,

        animation: 'none',
      }}
    >
      <Stack.Screen name="testage" options={{ title: 'Test Age' }} />
    </Stack>
  );
}
